import { PolicyCheck } from '@/features/auth/authorization';

export const GeneratorPolicies: Record<string, PolicyCheck> = {
  'equipment.generators.view': ({ acl, user, meta }) => {
    return acl.equipment.generators.view;
  },
  'equipment.generators.create': ({ acl, user, meta }) => {
    return acl.equipment.generators.create;
  },
  'equipment.generators.update': ({ acl, user, meta }) => {
    return acl.equipment.generators.edit;
  },
  'equipment.generators.delete': ({ acl, user, meta }) => {
    return acl.equipment.generators.delete;
  },
};
